import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { format } from "../commons/utils";
import { FormControl } from '@material-ui/core';

import useStyles from './useStyles'
import { ErrorMessage } from "@hookform/error-message";
import { singleInputValidator } from '../commons/utils';


const PasoUnoForm = ({ nombre, setNombre, rut, setRut, apellidoP, setApellidoP, apellidoM, setApellidoM, fechaNac, setFechaNac, genero, setGenero, aseguradora, setAseguradora, otro, setOtro, errors, setError, isapres, tipogenero, setData, setSpinner }) => {


  const classes = useStyles();

  const handleChange = (event) => {
    setAseguradora(event.target.value);
  };

  const handleChangeGenero = (event) => {
    setGenero(event.target.value);

  };

  const handleChangeRut = event => {
    if (event.target.value.length < 14) {
      setRut(format(event.target.value))
    }
  }

  const handleChangeNombre = event => {
    setNombre(event.target.value)
  }

  const hanldeChangeApellidoP = evt =>{
    setApellidoP(evt.target.value)
  }

  const hanldeChangeApellidoM = evt => {
    setApellidoM(evt.target.value)
  }

  const handleChangeFechaNac = evt => {
    setFechaNac(evt.target.value)
  }

  const handleChangeOtro = evt => {
    setOtro(evt.target.value)
  }

  /*
       const setRutUsuario = () => {
        const usrRut = (JSON.parse(sessionStorage.getItem('user')))
        return format(usrRut.rut)
      }
   */

  const [subTitulo, setSubTitulo] = useState('Antecedente de la persona que se contacta')

  const printAseguradoras = () => {
    return isapres.map((item,index)=>{
      return <MenuItem  key={index} value={item.codigo_isapre}>{item.nombre_isapre}</MenuItem>
    })
  }

  const printGenero = () => {
    return tipogenero.map((item,index)=>{
      return <MenuItem  key={index} value={item.id}>{item.descripcion}</MenuItem>
    })
  }




  return (


    <>
      {/* aca va el sub titulo del formulario */}
      <Box display="flex" justifyContent="start">
        <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
      </Box>
      {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
      <Grid>

      <FormControl className={classes.formControlComponent}>
          <TextField 
          onChange={handleChangeRut} 
          onBlur={() => singleInputValidator(rut,"Rut",setError, [{option:'rutValidation', updateFields:true}], setData, setSpinner)} 
          id="input-id" 
          variant="outlined" 
          label="Rut" 
          size="small" 
          name="Rut" 
          value={rut} />
          <ErrorMessage
            style={{ color: 'red' }}
            name="Rut"
            as="div"
            errors={errors}
          />
        </FormControl>


        <FormControl className={classes.formControlComponent}>
          <TextField onChange={handleChangeNombre} onBlur={() => {
            setNombre(nombre.trim())
            singleInputValidator(nombre,"Nombre",setError, [])
            }} id="input-id" variant="outlined" label="Nombre" size="small" name="Nombre" value={nombre} />
          <ErrorMessage
            style={{ color: 'red' }}
            name="Nombre"
            as="div"
            errors={errors}
          />
        </FormControl>


        <FormControl className={classes.formControlComponent}>
          <TextField 
          value={apellidoP} 
          onChange={hanldeChangeApellidoP} 
          onBlur={()=>{singleInputValidator(apellidoP, "apellidoP", setError, [])}}
          id="input-id" 
          variant="outlined" 
          label="Apellido Paterno" 
          size="small" 
          name="apellidoP" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="apellidoP"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
          <TextField 
          value={apellidoM} 
          onChange={hanldeChangeApellidoM} 
          onBlur={()=>{singleInputValidator(apellidoM, "apellidoM", setError, [])}}
          id="input-id" 
          variant="outlined" 
          label="Apellido Materno" 
          size="small" 
          name="apellidoM" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="apellidoM"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
          <TextField
            id="date"
            label="Fecha de Nacimiento"
            type="date"
            variant="outlined"
            size="small"
            sx={{ width: 220 }}
            InputLabelProps={{
              shrink: true,
            }}
            value={fechaNac}
            onChange={handleChangeFechaNac}
            onBlur={()=>{singleInputValidator(fechaNac, "fechaNac", setError, [])}}
            name="fechaNac"
          />
          <ErrorMessage
            style={{ color: 'red' }}
            name="fechaNac"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
         <InputLabel id="selectlabelGenero" variant="outlined" >Genero</InputLabel>
          <Select
            required
            labelId="generolabel"
            id="selectlabelGenero"
            variant="outlined"
            value={genero}
            label="Genero"
            onChange={handleChangeGenero}
            name="genero"
            
          >
            {printGenero()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="genero"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">

          <InputLabel id="selectlabelAseguradora" variant="outlined" >Aseguradora</InputLabel>
          <Select
            required
            labelId="aseguradoralabel"
            id="selectlabelAseguradora"
            variant="outlined"
            value={aseguradora}
            label="Aseguradora"
            onChange={handleChange}
            name="aseguradora"
           
          >
            {printAseguradoras()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="aseguradora"
            as="div"
            errors={errors}
          />

        </FormControl>
        <FormControl className={classes.formControlComponent}>
          <TextField value={otro} onChange={handleChangeOtro} id="input-id" variant="outlined" label="Otro" size="small" />
        </FormControl>


      </Grid>

    </>



  )
}

export default PasoUnoForm